// 🔧 use_promotion_content_studio.js
// ✅ Purpose: React hook for managing Promotion Studio actions
// ✅ Features:
// - Creates Promotion Posts
// - Exposes saving state
// - Keeps Promotion Studio pages free from service implementation details
// - Preserves clean page → hook → service → repository architecture
// - Future-ready for AI draft generation, rewrite tools, hashtags, CTAs, and image prompts
// - Fully block-commented for clarity and future devs

import { useState } from "react";

import {
  createPromotionContentDraft,
} from "../services/promotion_content_service";

/**
 * usePromotionContentStudio
 *
 * Central hook for Promotion Studio actions.
 *
 * Current MVP behavior:
 * - Creates Promotion Posts in Draft status.
 *
 * Future behavior:
 * - Generate AI draft
 * - Rewrite draft
 * - Adjust tone
 * - Generate hashtags
 * - Generate CTA
 * - Generate image prompt
 */
export const usePromotionContentStudio = () => {
  const [saving, setSaving] = useState(false);

  /**
   * saveDraft
   *
   * Creates a new Promotion Post.
   *
   * Every new Promotion Post begins in
   * Draft status.
   */
  const saveDraft = async (postPayload) => {
    setSaving(true);

    try {
      const createdPost =
        await createPromotionContentDraft(postPayload);

      return createdPost;
    } finally {
      setSaving(false);
    }
  };

  return {
    saving,

    saveDraft,
  };
};